import {Element} from "react-scroll";
import {Card, CardBody, CardText, Col, Container, Row} from "reactstrap";
import React from "react";
import GoogleMap from "./GoogleMap";
import {useTranslation} from "react-i18next";


function Contact() {
    const {t} = useTranslation();
    return (
        <Element name="contact">
            <Container className="my-5">
                <Card className="shadow-lg border-0 rounded-5 p-4">
                    <CardBody>
                        <h2 className="text-center text-success mb-5">
                            {t("contact")}
                        </h2>
                        <Row>
                            <Col md="6" className="mb-4">
                                <Card className="shadow-sm border-0 rounded-4 h-100">
                                    <CardBody>
                                        <CardText style={{color: "red"}}>
                                            <div className="text-left mt-4">
                                                <div className="mb-3">
                                                    <a href="mailto:benjaminzonic@gmail.com" className="text-dark mx-3">
                                                        <i className="bi bi-envelope">
                                                            <span>benjaminzonic@gmail.com</span>
                                                        </i>
                                                    </a>
                                                    <br/>
                                                    <br/>
                                                    <a href="tel:+38761094357" className="text-dark mx-3">
                                                        <i className="bi bi-telephone"><span>+387 61 094 357</span></i>
                                                    </a>
                                                    <br/>
                                                    <br/>
                                                    <a href="https://www.facebook.com/ecofriendlydoo" target="_blank"
                                                       rel="noreferrer"
                                                       className="text-dark mx-3">
                                                        <i className="bi bi-facebook">
                                                            <span> Eco-friendly doo</span>
                                                        </i>
                                                    </a>
                                                    <br/>
                                                    <br/>
                                                    <a href="https://www.instagram.com/ecofriendlydoo?igsh=ZWx6cHV6bGI1MTFn"
                                                       target="_blank" rel="noreferrer"
                                                       className="text-dark mx-3">
                                                        <i className="bi bi-instagram"><span> Eco-friendly doo</span>
                                                        </i>
                                                    </a>
                                                    <br/>
                                                    <br/>
                                                    <a href="https://maps.app.goo.gl/FPPfahXb4bGvQnQ49" target="_blank"
                                                       className="text-dark mx-3" rel="noreferrer">
                                                        <i className="bi bi-pin-map-fill">
                                                            <span>Titova bb, Donji Vakuf</span>
                                                        </i>
                                                    </a>
                                                    <br/>
                                                    <br/>
                                                </div>
                                            </div>
                                        </CardText>
                                    </CardBody>
                                </Card>
                            </Col>

                            <Col md="6" className="mb-4">
                                <Card className="shadow-sm border-0 rounded-4 h-100">
                                    <CardBody>
                                        <GoogleMap/>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </Container>
        </Element>
    )
}

export default Contact;